<template>
  <div class="evaluationpage">
    <!--<div class="resultlist">
      <span class="listline"></span>
      <p class="paylisttit">
        <span class="title">{{presentation.Name}}</span>
      </p>
      <div class="resultlistcon">
        <p>
          <span>申请单号：</span>
          <span>{{presentation.Code}}</span>
        </p>
        <p>
          <span>申请科室：</span>
          <span>{{presentation.ExecDptName}}</span>
        </p>
        <p>
          <span>开单医生：</span>
          <span>{{presentation.DoctName}}</span>
        </p>
        <p>
          <span>报告时间：</span>
          <span>{{presentation.Time}}</span>
        </p>
      </div>
    </div>-->
    <div class="noDate" v-show="!isShow">
      <div v-show="true" class="nolist">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt class="searchpic">
        <p class="center">暂无数据</p>
      </div>
    </div>
    <img :src="msgUrl" @click="gallery" />
  </div>
</template>
<script>
  import { GetEvaPresentation } from "@/services/getData.js";
  import weui from "weui.js";
  export default {
    name: "evaluation-report",
    data() {
      return {
        checkID: this.$route.query.checkID,
        presentation: [],
        msgUrl: "",
        isShow: true
      };
    },
    created: function () {
      this.getEvaPresentation();
    },
    methods: {
      gallery() {
        weui.gallery(this.msgUrl);
      },
      getEvaPresentation() {
        var loading = weui.loading("loading", {
          className: "custom-classname",
          content: "加载中"
        });
        GetEvaPresentation(this.checkID).then(response => {
          loading.hide();
          var _that = this;
          if (response.data.Result) {

            if (response.data.Extend.IsImg) {
              _that.isShow = true;
              _that.msgUrl = config.configURL + "GetEvaPlanImg?planID=" + _that.checkID;
            }
            else {
              _that.isShow = false;
              _that.msgUrl = '';
            }
          }
          else {
            _that.isShow = false;
            _that.msgUrl = '';
          }
        });
      }
    }
  };
</script>
<style>
  .weui-gallery__opr {
    display:none;
  }
  .evaluationpage {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

    .evaluationpage .resultlist {
      box-sizing: border-box;
      width: 100%;
      height: auto;
      background-color: white;
      position: relative;
      padding-bottom: 0.2rem;
      margin-bottom: 0.2rem;
    }

    .evaluationpage .paylisttit {
      font-size: 0.26rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #1592e4;
      border-bottom: 0.01rem solid rgba(61, 151, 209, 1);
      height: 0.79rem;
      line-height: 0.8rem;
      padding-left: 0.2rem;
      box-sizing: border-box;
      width: 100%;
    }

    .evaluationpage .resultlistcon {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
    }

    .evaluationpage .resultlist > .resultlistcon > p {
      width: 100%;
      border-bottom: 0.01rem dotted #dddddd;
      height: 0.79rem;
      line-height: 0.8rem;
      font-size: 0.26rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
    }

      .evaluationpage .resultlist > .resultlistcon > p:last-child {
        border-bottom: none;
      }

      .evaluationpage .resultlist > .resultlistcon > p > span:first {
        color: #333333;
        text-align: left;
      }

      .evaluationpage .resultlist > .resultlistcon > p > span:last-child {
        color: #999999;
        text-align: right;
        float: right;
      }

    .evaluationpage .resultlist > .paylresultlistconiscon > p:last-child {
      border-bottom: none;
    }

    .evaluationpage .listline {
      display: block;
      position: absolute;
      width: 0.08rem;
      height: 0.8rem;
      background: rgba(21, 146, 228, 1);
      top: 0;
      left: 0;
    }

    .evaluationpage .repostpic {
      width: 100%;
      height: auto;
      padding: 0 0.2rem;
      box-sizing: border-box;
    }

      .evaluationpage .repostpic > img {
        width: 100%;
        height: auto;
      }

  .prism-player {
    flex: 1;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/reportquery/evaluation-report.vue